import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Icon, IconName } from '../icon/index';
import { Typography } from '../typography/index';
import { useTheme } from '@mui/material';

interface NoDataProps {
	message: string | React.ReactNode;
	color?: string;
	icon?: IconName;
	width?: string;
	height?: string;
}

const NoDataBase = styled.div<{ $color?: string }>`
	color: ${props => props.color};
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const NoData = (props: NoDataProps) => {
	const { color, message } = props;
	const theme = useTheme();
	return (
		<NoDataBase $color={color}>
			<Icon
				iconName={props.icon ?? 'NoData'}
				sx={{ width: props.width ?? '24px', height: props.height ?? '24px', color: props.color ?? theme.palette.text.primary }}
			/>
			{typeof message == 'string' ? <Typography style={{ margin: 0 }}>{message}</Typography> : message}
		</NoDataBase>
	);
};
